/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon16Regular = forwardRef('ArrowCUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.973 10.534a.75.75 0 0 1-.007-1.06L6.76 5.63a1.75 1.75 0 0 1 2.483-.008L13.03 9.41a.75.75 0 0 1-1.06 1.06L8.18 6.684a.25.25 0 0 0-.354.002l-3.793 3.842a.75.75 0 0 1-1.06.007Z" })));
});
